import type { IntlShape } from 'react-intl-next';

import { NavigationMode, NavigationPeriodId } from '../../common/constants';
import { messages as commonMessages } from '../../common/messages';

import { navigationLabels } from './constants';

export const getScheduleViewOptions = (intlApi: IntlShape) => [
	{
		label: intlApi.formatMessage(commonMessages.timelineView),
		value: NavigationMode.Timeline,
	},
	{
		label: intlApi.formatMessage(commonMessages.calendarView),
		value: NavigationMode.Calendar,
	},
];

export const getTimelineTypeOptions = (intlApi: IntlShape) => [
	{
		label: intlApi.formatMessage(commonMessages.oneDay),
		value: NavigationPeriodId.OneDay,
	},
	{
		label: intlApi.formatMessage(commonMessages.oneWeek),
		value: NavigationPeriodId.OneWeek,
	},
	{
		label: intlApi.formatMessage(commonMessages.twoWeeks),
		value: NavigationPeriodId.TwoWeeks,
	},
	{
		label: intlApi.formatMessage(commonMessages.oneMonth),
		value: NavigationPeriodId.OneMonth,
	},
];

export const getNavigationLabels =
	(intlApi: IntlShape) => (period: NavigationPeriodId, scheduleName: string) => ({
		next: {
			aria: intlApi.formatMessage(commonMessages.inSchedule, {
				prefix: intlApi.formatMessage(commonMessages.nextPeriod, {
					period: intlApi.formatMessage(navigationLabels[period]),
				}),
				scheduleName,
			}),
			tooltip: intlApi.formatMessage(commonMessages.nextPeriod, {
				period: intlApi.formatMessage(navigationLabels[period]),
			}),
		},
		previous: {
			aria: intlApi.formatMessage(commonMessages.inSchedule, {
				prefix: intlApi.formatMessage(commonMessages.previousPeriod, {
					period: intlApi.formatMessage(navigationLabels[period]),
				}),
				scheduleName,
			}),
			tooltip: intlApi.formatMessage(commonMessages.previousPeriod, {
				period: intlApi.formatMessage(navigationLabels[period]),
			}),
		},
	});
